import axios from 'axios';
import * as jsonpatch from 'fast-json-patch';


export async function HandleAddCourse(course) {
    const url = 'api/exlCourseFront/addCourse/';

    const res = await axios.post(url, course).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res;
}

export async function HandleDuplicateCourse(course) {
    const url = 'api/exlCourseFront/duplicateCourse/';

    const res = await axios.post(url, course).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    data: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                data: null,
            };
        }
    );

    return res.data;
}

export async function HandleRemoveCourse(courseId) {
    const url = 'api/exlCourseFront/removeCourse/';
    const query = { courseId: courseId };

    const response = await axios.delete(url, { params: query }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, course: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    course: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                course: null,
            };
        }
    );
    return response;
}

export async function HandlePatchCourse(initialCourse, newCourse) {
    const patch = jsonpatch.compare(initialCourse, newCourse);
    let newPatch = [];

    patch.forEach((operation) => {
        var op = operation;
        op.oldValue = jsonpatch.getValueByPointer(initialCourse, op.path);

        newPatch.push(op);
    });


    const url = 'api/exlCourseFront/patchCourse/';
    const body = {
        id: initialCourse.id,
        EntityId: initialCourse.id,
        serializedPatch: JSON.stringify(newPatch),


    };

    const response = await axios.put(url, body).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, course: response.data };
            } else {
                return {
                    success: false,
                    error: response.data.message,
                    course: null,
                };
            }
        },
        (error) => {
            return {
                success: false,
                error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.',
                course: null,
            };
        }
    );
    return response;
}



export async function GetCourseById(courseId) {
    const uri = `api/exlCourseFront/getCourseById/`;
    const params = {
        courseId
    };

    const res = await axios.get(uri, {
        params,
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',
        }
    }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function GetCoursesByTeacherId(teacherId, filters) {
    const uri = `api/exlCourseFront/getCoursesByTeacherId/`;
    const params = {
        teacherId,
        filters
    };

    const res = await axios.get(uri, {
        params,
    }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function GetAllCourses() {
    const uri = `api/exlCourseFront/getAllCourses/`;

    const res = await axios.get(uri).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}

export async function GetCourses(pageSize, currentPage, direction, columnName, filters) {
    const uri = `api/exlCourseFront/getCourses/`;

    const params = {
        pageSize: pageSize,
        currentPage: currentPage,
        sortDirection: direction,
        sortColumn: columnName,
        filters: filters,
    };

    const res = await axios.get(uri, { params }).then(
        (response) => {
            if (response.status === 200) {
                return { success: true, error: null, data: response.data };
            } else {
                return { success: false, error: response.data.message, data: null };
            }
        },
        (error) => {
            return { success: false, error: 'Det gick inte att hämta datan, vänligen kontakta alltid@consid.se.', data: null };
        }
    );
    return res.data;
}